export default "__VITE_ASSET__D8lZ3dsb__"